import { useEffect, useState } from 'react'
import SectionContext from '../helpers/Context'
import TitleBlock from '../helpers/TitleBlock'
import { createGradientElement } from '../../helpers/markup'
import { lightOrDark, addBgImageClass } from '../../helpers/style'
import themeConfig from '../../../theme.config'

const Section = (props) => {
  // the api is sending out un-hashed hex colour strings, so we either make it the hashed version, or default to the base colour setting from the theme config.
  const [contained, setContained] = useState(false)
  const [backgroundColor, setBackgroundColor] = useState('#fff')
  const [gradientColor, setgradientColor] = useState('#fff')
  const [textShadow, setTextShadow] = useState(null)

  const sectionGradient = ![null, 'None', 'Text area'].includes(props.gradientType)
  const contentGradient = ['Text area'].includes(props.gradientType)

  useEffect(() => {
    setContained(() => props.backgroundConfiguration === 'Contained')
  }, [props.backgroundConfiguration])

  useEffect(() => {
    // we strip the '#' from the front by default because some sources of the data have it included, and some do not.
    // this sets everything to the same format, even though we add it back immediately after.
    const bgColor = props.backgroundColor?.replace('#', '')
    const fgColor = props.foregroundColor?.replace('#', '')
    setBackgroundColor((prevState) => (bgColor ? `#${bgColor}` : prevState))
    setgradientColor((prevState) => (fgColor ? `#${fgColor}` : prevState))
  }, [])

  useEffect(() => {
    setTextShadow(() => {
      if (!['always', 'images'].includes(themeConfig.settings.useTextShadow)) {
        return null
      }
      if (
        themeConfig.settings.useTextShadow === 'images' &&
        !props.mobileBackgroundImage &&
        !props.desktopBackgroundImage
      ) {
        return null
      }
      const theme = lightOrDark(backgroundColor)
      return `text-shadow shadow-${theme === 'dark' ? 'black' : 'white'}`
    })
  }, [backgroundColor])

  return (
    <section
      data-type={props.type}
      data-index={props.idx}
      style={{
        '--mobile-bg-url': props.mobileBackgroundImage ? `url(${props.mobileBackgroundImage.src})` : null,
        '--desktop-bg-url': props.desktopBackgroundImage ? `url(${props.desktopBackgroundImage.src})` : null,
        '--bg-color': backgroundColor ?? '#fff',
        '--light-or-dark': lightOrDark(backgroundColor),
      }}
      className={`${props.outerClass || ''} ${contained ? 'container mx-auto' : ''} ${textShadow} ${addBgImageClass(props.desktopBackgroundImage?.src, props.mobileBackgroundImage?.src)} bg-[color:var(--bg-color)] text-${lightOrDark(backgroundColor)}`}
    >
      <SectionContext.Provider value={{ base: backgroundColor }}>
        {sectionGradient &&
          createGradientElement({
            type: props.gradientType,
            fromColor: gradientColor,
            fullMobile: true,
          })}
        <div
          className={`inner container px-5 mx-auto ${props.innerClass || ''} ${contentGradient ? 'has-gradient' : ''}`}
        >
          {contentGradient &&
            createGradientElement({
              type: props.gradientType,
              fromColor: gradientColor,
              fullMobile: false,
            })}
          {props.sectionTitle !== false && (props.title || props.description) && <TitleBlock {...props} />}
          {props.children}
        </div>
      </SectionContext.Provider>
    </section>
  )
}

export default Section
